import './Maintenance.css';

import {Header} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';

const validateDownTime = (downTime) => {
  const downTimeFormat =
    /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-\d{4} (0[1-9]|1[0-2]):[0-5]\d (am|pm|AM|PM) - (0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-\d{4} (0[1-9]|1[0-2]):[0-5]\d (am|pm|AM|PM)$/;
  return downTimeFormat.test(downTime);
};

const Maintenance = (props) => {
  const {t} = useTranslation();

  return (
    <div>
      <div>
        <Header variant="jdf" navigationItems={[]}></Header>
      </div>
      <div className="maintainanceWrapper">
        <div className="maintainanceBody">
          <svg
            focusable="false"
            aria-hidden="true"
            fill="#666666"
            xmlns="http://www.w3.org/2000/svg"
            width="38.56"
            height="38.33"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"></path>
          </svg>
          <div className="maintenance-header">{t('SCHEDULE_MAINTENANCE')}</div>
          <br />
          <div className="maintenance-body">
            {validateDownTime(props.data_time) ? (
              <span>
                <span>{t('SCHEDULE_MAINTENANCE_MSG_WITH_TIME1')}</span>
                <span className="maintenance-time">{props.data_time}</span>
                {t('SCHEDULE_MAINTENANCE_MSG_WITH_TIME2')}
              </span>
            ) : (
              t('SCHEDULE_MAINTENANCE_MSG_WITHOUT_TIME')
            )}
            <br />
            <br />
            {t('THANKS_FOR_PATIENCE')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
